/* ****************************************************************************
Name:			  Cerfificate upload
**
** Desc:         This code is to manager supplier certificates
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  12/12/2020  Vasu Pabbaraju.           Added logic to validate sublot qty/number from excel = JIRA -- Q360-423
******************************************************************************/ 

import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import XLSX from 'xlsx';
import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';

import {
  Col, CardTitle,
  Card, Modal, ModalHeader, ModalBody, ModalFooter,
  CardBody, Button, InputGroupAddon
} from 'reactstrap';

//Get List of Open PO for the vendor Config
const GET_OPEN_PO = gql`
      query getOpenPO($VendorNum: String, $OpenPOFlag:String){
        SupplierPO(filters: {
           VendorNum:$VendorNum
           OpenPOFlag: $OpenPOFlag
    }) {
     edges {
       node {
         PONum
         MaterialNum
         MaterialRev
         POQty 
         RcvdQty
       }
     }
    }
  }
`;



//Get Inspections for a given PO,Part, Doc Version
const GET_INSPECTIONS = gql`
      query getInspections($VendorNum: String, $PartNum: String, $AgileDocIDVer: String){
        SupplierFileHeader(filters: {
        
          VendorNum: $VendorNum
          PartNum: $PartNum
          AgileDocIDVer: $AgileDocIDVer
    }) {
     edges {
       node {
         PartNum
         AgileDocIDVer
         MasterLotQty
         PONum
         Status
         FileGUID
         UpdateTS
         MasterLotNum
         mstrLotCompletionDate
         factPlanID
       }
     }
    }
  }

  `;

const UPDATE_REPORT = gql`
  mutation UpdateSupplierFile(
      $VendorNum: String
      $MasterLotNum: String
      $MasterLotQty: String
      $SubLotNum: String
      $SubLotQty: String
      $PartNum: String
      $Program: String
      $AgileDocIDVer: String
      $SupplierLogID: String
      $PONum: String
      $FileGUID: String
      $UpdateTS: String
      $factPlanID: Int
      $LoadTS: String
      $Status: String
      $sampleUnits: Int
      $timeOrder: Int
      $PackingSlipNum: String
      $PartialShipmentFlag: Int
      $inspData: String
      $mstrLotCompletionDate: String
  ) {
    UpdateSupplierFile(input: {
        VendorNum:$VendorNum
        MasterLotNum: $MasterLotNum
        MasterLotQty: $MasterLotQty
        SubLotNum: $SubLotNum
        SubLotQty: $SubLotQty
        PartNum:$PartNum
        Program: $Program
        AgileDocIDVer:$AgileDocIDVer
        SupplierLogID:$SupplierLogID
        PONum:$PONum
        UpdateTS:$UpdateTS
        LoadTS:$LoadTS
        sampleUnits: $sampleUnits
        timeOrder: $timeOrder
        factPlanID:$factPlanID
        PackingSlipNum: $PackingSlipNum
        PartialShipmentFlag: $PartialShipmentFlag
        mstrLotCompletionDate: $mstrLotCompletionDate
        FileGUID:$FileGUID
        inspData:$inspData
        Status: $Status
    }) {
      iDetail {
        FileGUID

    }
    }
  }`;

//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS = gql`
      query getPlanDetails($PartNum: String, $PartRev: String){
        vwApp1factplanspecsbypartrev(filters: {
           PartNum:$PartNum,
           PartRev:$PartRev
    },sort:COL_SL_NUM_ASC) {
     edges {
       node {
         PlanID
         PartNum
         PartDesc
         PartRev
         SpecId
         Label
         LabelNum
         Method
         LSL
         USL
         SpecDataType
         Precision
         ColIndex
         ColSlNum
         Sampling
         AQL
         Characteristic
         SpecType
         SpecVal
         SpecValMin
         SpecValMax
         SpecValTOLPlus
         SpecValTOLMinus
         BonusTOL
         NumPlaces
         BaloonNum
         SheetNum
       }
     }
    }
  }
`;

//Create a new report mutation config
const CREATE_REPORT = gql`
    mutation SupplierFileHeader(
       $VendorNum: String
       $MasterLotNum: String
       $MasterLotQty: Int
       $SubLotNum: String
       $SubLotQty: Int
       $PartNum: String
       $AgileDocIDVer: String
       $Program: String
       $SupplierLogID: String
       $PONum: String
       $FileGUID: String
       $UpdateTS: String
       $factPlanID: Int
       $LoadTS: String
       $Status: String
       $sampleUnits: Int
       $timeOrder: Int
       $PackingSlipNum: String
       $PartialShipmentFlag: Int
       $DetailString: String
       $mstrLotCompletionDate: String
    ) {
      SupplierFileHeader(input:{
    VendorNum:$VendorNum
    MasterLotNum: $MasterLotNum
    MasterLotQty: $MasterLotQty
    SubLotNum: $SubLotNum
    SubLotQty: $SubLotQty
    PartNum:$PartNum
    Program: $Program
    AgileDocIDVer:$AgileDocIDVer
    SupplierLogID:$SupplierLogID
    PONum:$PONum
    FileGUID:$FileGUID
    UpdateTS:$UpdateTS
    LoadTS:$LoadTS
    Status: $Status
    sampleUnits: $sampleUnits
    timeOrder: $timeOrder
    PackingSlipNum: $PackingSlipNum
    PartialShipmentFlag: $PartialShipmentFlag
    DetailString:$DetailString
    factPlanID:$factPlanID
    mstrLotCompletionDate: $mstrLotCompletionDate
  }){
    iHeader {
      FileGUID
      Status
    }
  }
}`;

//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS_PART = gql`
query getPlanDetails($PlanID: String){
      searchPlans(q:$PlanID) {
        __typename
        ... on  vw_App1FactPlanSpecsByPartRev {
      PartNum
      PartRev
      SpecId
      PlanID
      Label
      LabelNum
      Method
      Method2
      LSL
      USL
      Precision
      Sampling
      AQL
      ColIndex
      ColSlNum
      Characteristic
      SpecType
      SpecVal
      SpecValMin
      SpecValMax
      SpecValTOLPlus
      SpecValTOLMinus
      INSTRUCTIONS
      BaloonNum
      VersionNumDescOrd
      SpecDataType
      }

}
  }
`;

//Get Plan  by Part Number and Revision
const GET_PLANS = gql`
      query vwApp1factplan($PartNum: String, $PartRev: String) {
        vwApp1factplan(
          filters :{
            PartNum: $PartNum
            PartRev:$PartRev
            DelFlag:"0"
            Approved:"true"
          }
        ) {
          edges {
            node {
              PartNum
              PartRev
              PlanID
              DraftMode
              Released
              Approved
              VersionNumDescOrd
              
            }
          }
        }
      }
`;



const UploadCreate = ({ history }) => {

  const [GFinalData, setGFinalData] = useState(null)
  const [Error, setError] = useState(null);
  const [processState, setProcessState] = useState(false);
  const [poPartValidated, setPOPartValidated] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
  const [errorObject, setErrorObject] = useState(null);
  const [errorRecords, setErrorRecords] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [ispovalidated, setIspovalidated] = useState(false);
  const [disableCreate, setdisableCreate] = useState(true);
  const [SupplierFileHeader] = useMutation(CREATE_REPORT);
  const [UpdateSupplierFile] = useMutation(UPDATE_REPORT);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [ErrorText, setErrorText] = useState(null);
  const [inspections, setInspections] = useState(null);

  // Get list of OPEN PO for the logged in vendor
  const { data } = useQuery(GET_OPEN_PO, {
    fetchPolicy: 'no-cache',
    variables: { VendorNum: localStorage.getItem('loggedInVendor'), 'OpenPOFlag': '1' }
  });




  //Get Inspections
  const [getInspections] = useLazyQuery(GET_INSPECTIONS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setInspections(data.SupplierFileHeader.edges);
      // headerObject['MasterLotNum'] = GFinalData['header'][5]['MasterLotCell'];
      // headerObject['MasterLotQty'] = GFinalData['header'][6]['MasterLotQtyCell'];

      const checkInspections1 = data.SupplierFileHeader.edges.filter(inspections => inspections.node.MasterLotNum.toUpperCase() == GFinalData['header'][5]['MasterLotCell'].toUpperCase());
      
      if (checkInspections1.length > 0) {
        console.log(checkInspections1);
          if ( GFinalData['header'][6]['MasterLotQtyCell'] != checkInspections1[0].node.MasterLotQty) {
                      
              setErrorText('Master lot already exists, master lot quanity does not match with previous master lot submission')
              setShowErrorPopup(true);

          }
          console.log(new Date(GFinalData['header'][9]['InspectionDateCell']));
          console.log(new Date(checkInspections1[0].node.mstrLotCompletionDate));

          if (new Date(GFinalData['header'][9]['InspectionDateCell']).getTime()  !=  new Date(checkInspections1[0].node.mstrLotCompletionDate).getTime()  ) {
            setErrorText('Master lot already exists, master lot completion date does not match with previous master lot submission')
            setShowErrorPopup(true);

          }
      }

    }
  });




      // Verify PO/PART NUMBER/REV
      useEffect(() => {
          if (GFinalData && GFinalData != null) {
              console.log(GFinalData);
            getInspections({
              variables: { VendorNum: localStorage.getItem('loggedInVendor'), PartNum: GFinalData['header'][1].PartNumberCell, AgileDocIDVer: GFinalData['header'][3].AgileDocIDCell }
            });
            
          }
      }, [GFinalData]);


      const [getPlanDetailsData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
          setShowLoading(false);
          if (data.searchPlans.length > 0) {
    
            setPlanDetails(data.searchPlans);
    
          }
        }
      });

  const validatePOPart = (poNum, partNum, version) => {

    let validated = false;

    if (data.SupplierPO.edges.length > 0) {
      data.SupplierPO.edges.map((el, i) => {

        if (el.node.MaterialNum == partNum && el.node.MaterialRev == version) {
          setPOPartValidated(true);
          validated = true;
        }
      });
    }
    return validated;
  }


   //Get Plan details call
   const [getPlans] = useLazyQuery(GET_PLANS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
        if (data.vwApp1factplan.edges && data.vwApp1factplan.edges.length > 0) {
          data.vwApp1factplan.edges.map((el,i) => {
            if (el.node.VersionNumDescOrd == 1) {
            getPlanDetailsByPartData({ variables: { PlanID:el.node.PlanID } });
            }
          });
            
          
        } 
    }
  });

  const [getPlanDetailsByPartData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.searchPlans.length > 0) {
        setPlanDetails(data.searchPlans);
      }
    }
  })

  

  //function to handle submit operation
  const handleSubmit = async (status, headerObject, detailObject, planDetails, reportFileGUID) => {
    // const dirtyData = details.filter(data => data.dirty);
    setShowLoading(true);
    const res = await UpdateSupplierFile({
      variables: {
        VendorNum: localStorage.getItem('loggedInVendor'),
        MasterLotNum: headerObject['MasterLotNum'],
        MasterLotQty: headerObject['MasterLotQty'],
        SubLotNum: (headerObject['SubLotNum'] == null ? 0 : headerObject['SubLotNum']),
        SubLotQty: (headerObject['SubLotQty'] == null ? 0 : headerObject['SubLotQty']),
        PartNum: headerObject['PartNum'],
        AgileDocIDVer: headerObject['AgileDocIDVer'],
        Program: 0,
        SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
        PONum: headerObject['PONum'],
        FileGUID: reportFileGUID,
        UpdateTS: '',
        LoadTS: '',
        Status: 'Draft',
        sampleUnits: headerObject['sampleUnits'],
        inspData: detailObject,
        factPlanID: planDetails[0].PlanID,
        timeOrder: 0,
        PackingSlipNum: headerObject['PackingSlipNum'],
        PartialShipmentFlag: (headerObject['SubLotNum'].length > 0) ? 1 : 0,
        mstrLotCompletionDate: headerObject['mstrLotCompletionDate']
      }
    });

    if (res.data.UpdateSupplierFile.iDetail.FileGUID == 'Error processing') {
      setShowLoading(false);
    } else {
      if (status == 'Processed') {
        // getFileValidationDetails({ variables: { FileGUID: reportFileGUID } });
        // setShowSubmitConfirmation(true);
      } else {
        history.push({
          pathname: 'newreport',
          FileGUID: reportFileGUID
        });
        localStorage.setItem('selectedFile', reportFileGUID);
      }
      setShowLoading(false);

    }

  }

  //Create new port
  const createNewReport = () => {
    // if (PONum && AgileDocIDVer && PartNum && MasterLotNum && MasterLotNum && SubLotNum && SubLotQty && sampleUnits && sampleUnits && mstrLotCompletionDate) {

    setShowLoading(true);
    let headerObject = {};
    headerObject['PartNum'] = GFinalData['header'][1]['PartNumberCell'];
    headerObject['AgileDocIDVer'] = GFinalData['header'][3]['AgileDocIDCell'];
    headerObject['PONum'] = GFinalData['header'][4]['POCell'];
    headerObject['MasterLotNum'] = GFinalData['header'][5]['MasterLotCell'];
    headerObject['MasterLotQty'] = GFinalData['header'][6]['MasterLotQtyCell'];
    headerObject['SubLotNum'] = (GFinalData['header'][7]['SublotNumCell'] == 'N/A')?'':GFinalData['header'][7]['SublotNumCell'];
    headerObject['SubLotQty'] = (GFinalData['header'][8]['SublotQtyCell'] == 'N/A')?'':GFinalData['header'][8]['SublotQtyCell'];
    headerObject['sampleUnits'] = GFinalData['header'][11]['SampleUnitCell'];
    headerObject['TimeOrdered'] = 0;
    headerObject['Program'] = 0;
    headerObject['mstrLotCompletionDate'] = GFinalData['header'][9]['InspectionDateCell'];
    headerObject['PackingSlipNum'] = GFinalData['header'][10]['PackingSlipCell'];


    const tPlanDetails = planDetails;
    let valueObject = GFinalData['values'];
    let detailData = [];

    valueObject.map((el, i) => {

      el.values.map((el1, j) => {
        if (el1['sampling'].trim() == '1 per lot') {
          if (i == 0) {
            let detail = {};
            detail['UnitNo'] = el['unit'];
            detail['Label'] = el1['label'].label;
            detail['Method'] = el1['method'];
            detail['Sampling'] = el1['sampling'];
            if (isNaN(Number(el1['value'])) && el1['value'].toUpperCase().trim() == 'PASS') {
              detail['Val'] = el1['value'].toUpperCase().trim();
            } else {
              detail['Val'] = el1['value'].toString().trim();;
            }
            detail['ColIndex'] = el1['ColIndex'];
            detail['ColSlNum'] = el1['ColSlNum'];
            detail['LabelNum'] = el1['LabelNum'];
            detail['cavityID'] = el['cavityID'];
            detail['samplingTime'] = el['sampleTime'];
            detail['subGroup'] = el['subgroup'];
            detail['bonus'] = null;

            detail['dirty'] = "true";
            detailData.push(detail);
          }
        } else {
          let detail = {};
          detail['UnitNo'] = el['unit'];
          detail['Label'] = el1['label'].label;
          detail['Method'] = el1['method'];
          detail['Sampling'] = el1['sampling'];
          ////console.log(Number(el1['value']));
          if (isNaN(Number(el1['value'])) && el1['value'].toUpperCase().trim() == 'PASS') {
            detail['Val'] = el1['value'].toUpperCase().trim();
          } else {
            detail['Val'] = el1['value'].toString().trim();
          }
          
          
          detail['ColIndex'] = el1['ColIndex'];
          detail['ColSlNum'] = el1['ColSlNum'];
          detail['LabelNum'] = el1['LabelNum'];
          detail['cavityID'] = el['cavityID'];
          detail['samplingTime'] = el['sampleTime'];
          detail['subGroup'] = el['subgroup'];
          detail['bonus'] = null;

          detail['dirty'] = "true";
          detailData.push(detail);
        }
      });
    });



    ////console.log(detailData);
    let tdetails = detailData; //GFinalData['values'];
    insertData(headerObject, tdetails, tPlanDetails);




  }

  const insertData = async (headerObject, detailObject, planDetails) => {
    ////console.log(headerObject);
    const res = await SupplierFileHeader({
      variables: {
        VendorNum: localStorage.getItem('loggedInVendor'),
        MasterLotNum: headerObject['MasterLotNum'],
        MasterLotQty: parseInt(headerObject['MasterLotQty']),
        SubLotNum: (headerObject['SubLotNum'].toLowerCase() == "n/a" ? 0 : headerObject['SubLotNum']),
        SubLotQty: parseInt(headerObject['SubLotQty'].toLowerCase() == "n/a" ? 0 : headerObject['SubLotQty']),
        PartNum: headerObject['PartNum'],
        AgileDocIDVer: headerObject['AgileDocIDVer'],
        Program: headerObject['Program'],
        SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
        PONum: headerObject['PONum'],
        FileGUID: '',
        UpdateTS: '',
        LoadTS: '',
        Status: 'Draft',
        sampleUnits: headerObject['sampleUnits'],
        DetailString: [],
        factPlanID: planDetails[0].PlanID,
        timeOrder: (headerObject['TimeOrdered'].toString().toUpperCase() == 'TRUE' ? 1 : 0),
        PackingSlipNum: headerObject['PackingSlipNum'],
        PartialShipmentFlag: (headerObject['SubLotNum'].length> 0 && headerObject['SubLotNum'].toLowerCase() != 'n/a' && headerObject['SubLotQty'] > 0) ? 1:0,
        mstrLotCompletionDate: headerObject['mstrLotCompletionDate']
      }
    });

    if (res.data.SupplierFileHeader.iHeader.FileGUID.trim() == 'Error processing') {
      setShowLoading(false);
      alert(res.data.SupplierFileHeader.iHeader.Status);
    } else if (res.data.SupplierFileHeader.iHeader.FileGUID == 'Full shipment is already done for this MasterLotNum') {
      alert('Full shipment is already done for this MasterLotNum');
      setShowLoading(false);
    } else {


      setShowLoading(false);
      handleSubmit('Draft', headerObject, JSON.stringify(detailObject), planDetails, res.data.SupplierFileHeader.iHeader.FileGUID)
      //   setReportFileGUID(res.data.SupplierFileHeader.iHeader.FileGUID);
      //   setReportMode('Draft');
      //   setSubgroupData(detailObject, headerObject);

      //   getReportDetail({ variables: { FileGUID: res.data.SupplierFileHeader.iHeader.FileGUID } });
    }
  };

  const validatePlan = () => {
    let loadedLabels = GFinalData['labels'];
    let planMatched = false;
    let broken = false;
    loadedLabels.map((el, i) => {
      if (planDetails[i]) {
        if (el['label'] == planDetails[i].Label) {
          planMatched = true;
        } else {
          planMatched = false;
          broken = true;
          setErrorText('Plan Validation failed');
          setShowErrorPopup(true);
          el['error'] = true;
        }
      }

    });

    let tGfinalData = GFinalData;
    tGfinalData['labels'] = loadedLabels;
    ////console.log(tGfinalData['labels'])
    setGFinalData(tGfinalData);


    return planMatched;
  }

  const validateUnitValues = () => {

    const unitValues = GFinalData['values'];
    let valuesMatched = false;
    let broken = false;
    let tErrorRecords = [];
    unitValues.map((el, i) => {
      
      // if (!broken) 
      {
        const unitData = el['values'];

        unitData.map((el1, j) => {
        
          
            if (el1) {
         
            
            if (el1['label']['label'] == planDetails[j]['Label']) {
              el1['ColIndex'] = planDetails[j]['ColIndex'];
              el1['ColSlNum'] = planDetails[j]['ColSlNum'];
              el1['LabelNum'] = planDetails[j]['LabelNum'];
              el1['Precision'] = planDetails[j]['Precision'];
              el1['cavityID'] = '';
              el1['samplingTime'] = '';
              el1['subGroup'] = '';
              el1['bonus'] = '';
              
              if (planDetails[j]['SpecDataType'] == 'Attribute') {
                if (planDetails[j]['Sampling'].trim() == '1 per lot') {
                  if (i == 0 && el1['value'].trim().toUpperCase() != 'PASS') {
                   
                    broken = true;
                    valuesMatched = false;
                    console.log('failed1')
                    setErrorObject({ "unit": i+1, "value": el1 });
                    tErrorRecords.push({ "unit": i+1, "value": el1 });
                    el1['error'] = true;
                  } else {

                    valuesMatched = true;
                  }
                } else {
                  if (el1['value'].trim().toUpperCase() != 'PASS') {

                    broken = true;
                    valuesMatched = false;
                    console.log('failed2')
                    setErrorObject({ "unit": i+1, "value": el1 });
                    tErrorRecords.push({ "unit": i+1, "value": el1 });
                    el1['error'] = true;
                  } else {

                    valuesMatched = true;
                  }
                }
              }
              else {



                if (planDetails[j]['SpecType'] == 'GD&T' && planDetails[j]['BonusTOL'] == 1) {

                  let lsl = Number((planDetails[j]['SpecValTOLMinus'] == null) ? 0 : planDetails[j]['SpecValTOLMinus']);
                  let usl = Number(planDetails[j]['SpecValTOLPlus']);
                
                  if (Number(el1['value']) < lsl || Number(el1['value']) > usl) {
                    broken = true;
                    valuesMatched = false;
                    console.log('failed3')
                    setErrorObject({ "unit": i+1, "value": el1 });
                    tErrorRecords.push({ "unit": i+1, "value": el1 });
                    el1['error'] = true;
                  } else {

                    valuesMatched = true;
                  }

                } else {
                  let lsl = Number(planDetails[j]['LSL']).toFixed(planDetails[j].Precision);
                  let usl = Number(planDetails[j]['USL']).toFixed(planDetails[j].Precision)
                  if (planDetails[j].SpecType == 'GD&T') {
                    lsl = Number(planDetails[j].SpecValTOLMinus).toFixed(planDetails[j].Precision);
                    usl = Number(planDetails[j].SpecValTOLPlus).toFixed(planDetails[j].Precision)
                  }

                  ////console.log(el1['value']);
                  ////console.log(Number(el1['value'].toFixed(Number(planDetails[j]['Precision']))) + '---' +Number(planDetails[j]['LSL']) + '----' + Number(planDetails[j]['USL']));
                  if (lsl  > 0 && usl == 0) {
                    if (isNaN(Number(el1['value'])) || Number(el1['value']) <  lsl ) {
                      broken = true;
                      valuesMatched = false;
                      console.log('failed4')
                      setErrorObject({ "unit": i+1, "value": el1 });
                      tErrorRecords.push({ "unit": i+1, "value": el1 });
                      el1['value'] = el1['value'];
                      el1['error'] = true;
                    } else {
                      el1['value'] = Number(el1['value'].toFixed(Number(planDetails[j]['Precision'])));
                      valuesMatched = true;
                    }
                  } else {                  
                    if (isNaN(Number(el1['value'])) || Number(el1['value']) < lsl || Number(el1['value']) > usl) {
                      broken = true;
                      valuesMatched = false;
                      console.log('failed5')
                      setErrorObject({ "unit": i+1, "value": el1 });
                      tErrorRecords.push({ "unit": i+1, "value": el1 });
                      el1['value'] = el1['value'];
                      el1['error'] = true;
                    } else {
                      el1['value'] = Number(el1['value'].toFixed(Number(planDetails[j]['Precision'])));
                      valuesMatched = true;
                    }
                  }
                }
              }
            }
          } else {
            setErrorText('Please make sure to enter valid Unit values')
            setShowErrorPopup(true);
          }
        });


      }

    });
    let tGfinalData = GFinalData;
    tGfinalData['values'] = unitValues;
    ////console.log(unitValues);
    setGFinalData(tGfinalData);
    setErrorRecords(tErrorRecords);
    if (tErrorRecords.length>0) {
      setShowErrorPopup(true);
    }
    return valuesMatched;
  }

  useEffect(() => {
    if (errorObject) {
      ////console.log(errorObject);
    }
  }, [errorObject]);

  useEffect(() => {
    if (GFinalData && GFinalData['values'].length > 0) {
      if (planDetails) {
        const planMatched = validatePlan();

        if (planMatched && !showErrorPopup) {
          const valuesMatched = validateUnitValues();
          if (valuesMatched) {
            setdisableCreate(false);
          }
          setShowLoading(false);
        } else {
          setShowLoading(false);
        }
      }
    }
  }, [planDetails, GFinalData]);



  const processWorksheet = (ws) => {
    setShowLoading(true);
    let processErrrors = []; //JSON Object to tag Errrors
    let processedHeaderData = []; //JSON Object to hold data
    let finalData = {};
    //Header Data Mapping
    const headerMap = {
      "SupplierCell": 'B2',
      "PartNumberCell": 'B3',
      "PartDescCell": 'B4',
      "AgileDocIDCell": 'B5',
      "POCell": 'F2',
      "MasterLotCell": 'F3',
      "MasterLotQtyCell": 'F4',
      "SublotNumCell": 'F5',
      "SublotQtyCell": 'F6',
      "InspectionDateCell": 'F7',
      "PackingSlipCell": 'F8',
      "SampleUnitCell": 'B6'
    };

    // Process Header data

    for (var key in headerMap) {
     
      

      let headerObject = {};
      if (ws[headerMap[key]]) {
        ////console.log(ws[headerMap[key]].w)
        headerObject[key] = ws[headerMap[key]]['w']
      } else {
        headerObject[key] = "";
      }

      processedHeaderData.push(headerObject);
    
    }


    finalData['header'] = processedHeaderData;
  
    if (finalData['header'][1].PartNumberCell != '' && finalData['header'][3].AgileDocIDCell != '') {
      let validated = validatePOPart(finalData['header'][4].POCell, finalData['header'][1].PartNumberCell, finalData['header'][3].AgileDocIDCell);
      
      setIspovalidated(validated);
      if (validated) {


        getPlans({
          variables: {
            PartNum: finalData['header'][1].PartNumberCell,
            PartRev: finalData['header'][3].AgileDocIDCell
          }
        });
      } else {
        setErrorText('PO,Part Number, Revision validation Failed')
        setIspovalidated(false);
        setShowLoading(false);
        setShowErrorPopup(true);
      }
    } else {
     
      setIspovalidated(false);
      setShowLoading(false);
      setShowErrorPopup(true);
    }

    if (finalData['header'][5].MasterLotCell == '') {
      setErrorText('Please enter master lot')
      setShowErrorPopup(true);
    }

    if (finalData['header'][6].MasterLotQtyCell == '' || !Number(finalData['header'][6].MasterLotQtyCell)) {
      setErrorText('Please enter master lot quantity')
      setShowErrorPopup(true);
    }


    if (finalData['header'][7].SublotNumCell == '' && finalData['header'][7].SublotNumCell.toLowerCase() != 'n/a') {
      setErrorText('Please enter sublot number, if not partial shipment, enter N/A')
      setShowErrorPopup(true);
    } 


    if (finalData['header'][7].SublotNumCell != '' && finalData['header'][7].SublotNumCell != 'N/A') {
        if (finalData['header'][8].SublotQtyCell =='' || finalData['header'][8].SublotQtyCell == 'N/A' || isNaN(Number(finalData['header'][8].SublotQtyCell)) || Number(finalData['header'][8].SublotQtyCell) == 0) {
          setErrorText('Please enter sublot quanity')
          setShowErrorPopup(true);
        } else {
          if (Number(finalData['header'][8].SublotQtyCell) > Number(finalData['header'][6].MasterLotQtyCell)  ) {
            setErrorText('Sub lot quantity cannot be more than Master Lot Quantity');
            setShowErrorPopup(true);
          }
        }
    } else if (finalData['header'][7].SublotNumCell == 'N/A' && Number(finalData['header'][8].SublotQtyCell) && Number(finalData['header'][8].SublotQtyCell) > 0) {
      setErrorText('Please make sure to enter valid sublot Number')
      setShowErrorPopup(true);
    }

    if (finalData['header'][9].InspectionDateCell == '') {
      setErrorText('Please enter master lot completion date')
      setShowErrorPopup(true);
    } else {
      if (new Date(finalData['header'][9].InspectionDateCell).getTime() > new Date().getTime()) {
        setErrorText('Master lot completion date cannot be in the future');
        setShowErrorPopup(true);
      }
    
    }
   console.log((Number(finalData['header'][11].SampleUnitCell) , Number(finalData['header'][6].MasterLotQtyCell)))
    if (!finalData['header'][11].SampleUnitCell || !Number(finalData['header'][11].SampleUnitCell>0)) {
      setErrorText('Please make sure to enter sample unit size');
      setShowErrorPopup(true);
    } else if (Number(finalData['header'][11].SampleUnitCell) > Number(finalData['header'][6].MasterLotQtyCell)) {
      setErrorText('Please make sure sample units are less than master lot quantity');
      setShowErrorPopup(true);
    }

    
    

    var range = XLSX.utils.decode_range(ws['!ref']);

    //Check if label,method and Sampling are there are not:

    try {
      if (ws['B12'].v.toLowerCase() != "label") {
        processErrrors.push({ 'Cell': 'Label' });
      }
    }
    catch (er) {
      processErrrors.push({ 'Cell': 'Label' });
    }
    try {
      if (ws['B13'].v.toLowerCase() != "inspection method") {
        processErrrors.push({ 'Cell': 'Inspection Method' });
      }
    }
    catch (er) {
      processErrrors.push({ 'Cell': 'Inspection Method' });
    }

    try {
      if (ws['B14'].v.toLowerCase() != "sampling") {
        processErrrors.push({ 'Cell': 'sampling' });
      }
    }
    catch (er) {
      processErrrors.push({ 'Cell': 'sampling' });
    }

    let startCol = 3;


    
    // Get Label data
    let sheets = [];
    let baloons = [];
    let Characteristics = [];
    let labels = [];
    let methods = [];
    let sampling = [];
    let LSLUSL = [];
    for (let rowNum = 10; rowNum <= 16; rowNum++) {
      for (var C = startCol; C <= range.e.c; ++C) {
        // Example: Get second cell in each row, i.e. Column "B"
       
        const secondCell = ws[XLSX.utils.encode_cell({ r: rowNum, c: C })];
        if (secondCell != undefined) {
          try {
            if (rowNum == 10) {
              sheets.push({ 'sheet': secondCell.v })
            } else if (rowNum == 11) {
              baloons.push({ 'baloon': secondCell.v })
            } else if (rowNum == 12) {
              Characteristics.push({ 'characteristic': secondCell.v })
            } else
              if (rowNum == 13) {
                labels.push({ 'label': secondCell.v })
              } else if (rowNum == 14) {
                methods.push(secondCell.v)
              } else if (rowNum == 15) {
                sampling.push(secondCell.v)
              } else if (rowNum == 16) {
                LSLUSL.push(secondCell.v)
              }
          } catch (er) {
            ////console.log(er);

          }
        }
      }
    }
    
    finalData['sheets'] = sheets;
    finalData['baloons'] = baloons;
    finalData['Characteristics'] = Characteristics;
    finalData['labels'] = labels;
    finalData['methods'] = methods;
    finalData['sampling'] = sampling;
    finalData['LSLUSL'] = LSLUSL
    //Get Number of Units
    let units = 0;
    let unitNumbers = [];

    for (let rowNum = 17; rowNum <= range.e.r; rowNum++) {
      const secondCell = ws[XLSX.utils.encode_cell({ r: rowNum, c: 0 })];

      if (secondCell != undefined) {
        if (Number(secondCell.v) > 0) {
          unitNumbers.push(Number(secondCell.v));
          units++;
        }
      }
    }

    if (Number(finalData['header'][11].SampleUnitCell) != units) {
      setErrorText('Please make sure sample unit size and number of units provided are equal  ');
      setShowErrorPopup(true);
    }
    


    //Get Values
    let startRow = 17;

    // for (let row=0; row<units; row++) {
    let values = [];
    let unit = 1;

  
    for (let rowNum = startRow; rowNum <= (startRow + units) - 1; rowNum++) {
      let unitValues = [];
      let labelCount = 0;
      for (var C = startCol; C <= Number(methods.length) + Number(startCol - 1); ++C) {
        const secondCell = ws[XLSX.utils.encode_cell({ r: rowNum, c: C })];
       
        if (secondCell && secondCell != undefined) {
        
          unitValues.push({ "label": labels[labelCount], "method": methods[labelCount], "sampling": sampling[labelCount], "value": secondCell.v })
        } else {
          unitValues.push({ "label": labels[labelCount], "method": methods[labelCount], "sampling": sampling[labelCount], "value": "" })

          //  if (C == 2 || C == 3) {
          // unitValues.push({ "label": labels[labelCount], "method": methods[labelCount], "sampling": sampling[labelCount], "value": "" })
          //  }

        }
        labelCount++;

      }
      ////console.log('--------')
      let cavityID = "";
         let cavityCell = ws[XLSX.utils.encode_cell({ r: rowNum, c: 1 })];
        if (cavityCell != undefined) {
          cavityID = cavityCell.v;
        }
        values.push({ "unit": unit, "cavityID": cavityID, "values": unitValues });
       unit++;
    }

  
    
    ////console.log(values);
    finalData['values'] = values;

    setGFinalData(finalData);
    ////console.log(finalData);




    setProcessState(true);
    setShowLoading(false);

    //  setValueTable(tvalueTable);
    //  setLabelRow(tlabelRow);
    //  setMethodsRow(setMethodsRow);
    //  setSamplingRow(tsamplingRow);

  }

  let tsheets = (!GFinalData || !GFinalData.sheets) ? null : GFinalData.sheets.map((el, i) => {
    return (
      <th style={{ border: (el.error) ? '1px solid red' : '1px solid #e9ecef' }} key={i}>{el.sheet}

        <i style={{ display: (el.error) ? 'inline' : 'none', float: 'right' }} class="fas fa-times-circle"></i> </th>
    )

  });

  let tbaloons = (!GFinalData || !GFinalData.baloons) ? null : GFinalData.baloons.map((el, i) => {
    return (
      <th style={{ border: (el.error) ? '1px solid red' : '1px solid #e9ecef' }} key={i}>{el.baloon}

        <i style={{ display: (el.error) ? 'inline' : 'none', float: 'right' }} class="fas fa-times-circle"></i> </th>
    )

  });

  let tcharacterstics = (!GFinalData || !GFinalData.Characteristics) ? null : GFinalData.Characteristics.map((el, i) => {
    return (
      <th style={{ border: (el.error) ? '1px solid red' : '1px solid #e9ecef' }} key={i}>{el.characteristic}

        <i style={{ display: (el.error) ? 'inline' : 'none', float: 'right' }} class="fas fa-times-circle"></i> </th>
    )

  });

  let tlabelRow = (!GFinalData || !GFinalData.labels) ? null : GFinalData.labels.map((el, i) => {
    return (
      <th style={{ border: (el.error) ? '1px solid red' : '1px solid #e9ecef' }} key={i}>{el.label}

        <i style={{ display: (el.error) ? 'inline' : 'none', float: 'right' }} class="fas fa-times-circle"></i> </th>
    )

  });
  let tmethodsRow = (!GFinalData || !GFinalData.methods) ? null : GFinalData.methods.map((el, i) => {
    return (

      <th style={{ border: '1px solid #e9ecef' }} key={i}>{el}</th>

    )
  });
  let tsamplingRow = (!GFinalData || !GFinalData.sampling) ? null : GFinalData.sampling.map((el, i) => {
    return (

      <th style={{ border: '1px solid #e9ecef' }} key={i}>{el}</th>

    )
  });

  let tlslusl = (!GFinalData || !GFinalData.LSLUSL) ? null : GFinalData.LSLUSL.map((el, i) => {
    return (

      <th style={{ border: '1px solid #e9ecef' }} key={i}>{el}</th>

    )
  });

  let t_errors = (!errorRecords) ? null : errorRecords.map((el, i) => {
    return (
      (i<10)?
      <li style={{textAlign:'left'}}>Specification validation errors in Unit {el.unit}</li>:null

    )
  });
  
  console.log(GFinalData)

  let tvalueTable = (!GFinalData || !GFinalData.values) ? null : GFinalData.values.map((el, i) => {
    let unit = el.unit;

    return (
      <tr key={i}>
        <th style={{ border: '1px solid #e9ecef' }}> {el.unit} </th>
       
        <th style={{ border: '1px solid #e9ecef' }}>{el.cavityID}</th><th></th>
        {
          el.values.map((el1, j) => {
            return (

              <th style={{ border: (el1.error) ? '1px solid red' : '1px solid #e9ecef' }} key={j}>
                {el1.value}
                <i style={{ display: (el1.error) ? 'inline' : 'none', float: 'right' }} class="fas fa-times-circle"></i>
              </th>
            )
          })

        }
      </tr>
    )

  });

  console.log(errorRecords)
  console.log(ErrorText)
  

  const fileHandler = (event) => {
    if (event.target.files.length) {
      let fileObj = event.target.files[0];
      let fileName = fileObj.name;
      //check for file extension and pass only if it is .xlsx and display error message otherwise
      if (fileName.slice(fileName.lastIndexOf('.') + 1) === "xlsx") {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          ////console.log(wb);
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          processWorksheet(ws);
        };
        reader.readAsBinaryString(fileObj);
      }
      else {
       alert('Please upload an excel file');
      }
    }
  }

  return (
    <div >
      {(data) ?
        <Card id='entryDiv' style={{ margin: '1%' }}>
          <CardBody>
              <CardTitle>Please upload inspection report</CardTitle>
        <input type="file" onClick={(e) => {e.target.value='';setErrorText(null); setErrorRecords(null);}} onChange={fileHandler.bind(this)} id="input" />
        </CardBody>
        </Card>
        : null}
      {GFinalData &&
        <div>
          <Card id='entryDiv' style={{ margin: '1%' }}>
            <CardBody>
              <CardTitle>Inspection Details</CardTitle>
              <table class="table table-striped" style={{ marginTop: '20px' }}>
                <tr>
                  <th> Supplier </th><td>{localStorage.getItem('loggedInVendor')}</td>
                  <th> Purchase Order # </th><td>{GFinalData['header'][4].POCell}
                    <i style={{ display: (!ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-times"></i>
                    <i style={{ display: (ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-check"></i> </td>
                </tr>
                <tr>
                  <th> Part Number/Rev </th><td>{GFinalData['header'][1].PartNumberCell}
                    <i style={{ display: (!ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-times"></i>
                    <i style={{ display: (ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-check"></i></td>
                  <th> Master Lot # </th><td>{GFinalData['header'][5].MasterLotCell}</td>
                </tr>
                <tr>
                  <th> Part Descr. </th><td>{GFinalData['header'][2].PartDescCell}</td>
                  <th> Master Lot Quantity </th><td>{GFinalData['header'][6].MasterLotQtyCell}</td>
                  {/* <th> Prepared By </th><td>{JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase()}</td> */}
                </tr>
                <tr>
                  <th> Agile Doc ID/Rev </th><td>{GFinalData['header'][3].AgileDocIDCell}
                    <i style={{ display: (!ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-times"></i>
                    <i style={{ display: (ispovalidated) ? 'inline' : 'none', marginLeft: '5px' }} class="fas fa-check"></i></td>
                  <th>  Sub Lot #  </th><td>{GFinalData['header'][7].SublotNumCell}</td>
                </tr>
                <tr>
                  <th> Sample Units </th><td>{GFinalData['header'][11].SampleUnitCell}</td>
                  <th>  Sub Lot Quantity  </th><td>{GFinalData['header'][8].SublotQtyCell}</td>
                </tr>
                <tr>
             
                  <th>  </th><td></td>
                  <th>   Master Lot Completion Date   </th><td>{GFinalData['header'][9].InspectionDateCell}</td>
                </tr>
                <tr>
                  <th> </th><td></td>
                  <th>  Packing Slip / Delivery number   </th><td>{GFinalData['header'][10].PackingSlipCell}</td>
                </tr>
                {/* <tr>
                  <th> Time Ordered? </th><td>{GFinalData['header'][12].TimeOrderedCell.toString().toLowerCase()}</td>
                  <th>  Master Lot Completion Date  </th><td>{GFinalData['header'][9].InspectionDateCell}</td>
                </tr>
                <tr>
                  <th> Subgroup Size </th><td>{GFinalData['header'][13].SubgroupSize}</td>
                  <th>  Packing Slip / Delivery number   </th><td>{GFinalData['header'][10].PackingSlipCell}</td>
                </tr> */}
                <tr>
                  <th>  </th><td></td>
                  <th> Prepared By </th><td>{JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase()}</td>
                </tr>
                {/* <tr>
<th> Program </th><td>{GFinalData['header'][4].ProgramCell}</td>
<th> Lot Accept / Reject </th><td>{GFinalData['header'][9].LotAcceptReject}</td>
</tr> */}
              </table>
            </CardBody>
          </Card>
          <Card id='entryDiv' style={{ margin: '1%', overflow: 'scroll' }}>
            <CardBody>
              <CardTitle>Measurements Details
              
    <Button style={{ float: 'right' }} onClick={createNewReport} disabled={disableCreate || (errorRecords && errorRecords.length > 0) || ErrorText} color="primary">Create Report</Button>{' '}


              </CardTitle>
              <table class="table table-striped" style={{ marginTop: '20px' }}>
                <tr>
                  
                  <th></th><th></th><th>Sheet</th>{tsheets}</tr>


                <tr>
                  
                  <th></th><th></th><th>Baloon</th>{tbaloons}</tr>


                <tr>
                 
                  <th></th><th></th><th>Characteristic</th>{tcharacterstics}</tr>


                <tr>
                 
                  <th></th><th></th><th>Label*</th>{tlabelRow}</tr>
                <tr>
                 
                  <th></th><th></th><th>Method</th>{tmethodsRow}</tr>
                <tr>
                 
                  <th></th><th></th><th>Sampling</th>{tsamplingRow}</tr>
              
                  <tr><th>Unit #</th><th> Cavity ID, Serial #, Machine ID (Optional) </th><th></th>
                    {tlslusl}
                  </tr>
                {tvalueTable}
              </table>



            </CardBody>
          </Card>
        </div>
      }
      <SweetAlert
        show={showErrorPopup}
        warning
        title="Validation Errors"
        onCancel={() => setShowErrorPopup(false)}
        onConfirm={() => setShowErrorPopup(false)}
        focusCancelBtn
      >
        {(ErrorText)?
        <div>
          <ul>
            <li>{ErrorText}</li>
          </ul>

        </div>:null}
        {(t_errors)?
        <div>
          <ul>
            {t_errors}
          </ul>

        </div>: null}
      </SweetAlert>
      <Modal isOpen={showLoading}>
        <ModalBody>
          {showLoading ?
            <div style={{ width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
              <div class="spinner-border m-5" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div style={{ width: '100%', textAlign: "center", marginTop: '20px', fontSize: '20px' }}> Processing ..... </div>
            </div> : null}
        </ModalBody>  </Modal>
    </div>





  )




}

export default (withRouter(UploadCreate))
